export default __webpack_public_path__ + "static/media/logo-04.ac3cc5a5.png";